import { useMemo } from 'react';
import { useQuery } from 'react-query';

import { getCaseDamages } from '@ge/feat-monitor/services';
import { QueryKey } from '@ge/models/constants';
import { useTableFilter } from '@ge/shared/data-hooks/use-table-filter';
import { sorter } from '@ge/util/metric-sorter';

export const useCaseDamagesTable = ({
  filters,
  search,
  sortMetric,
  sortDirection,
  damages,
  isCaseDamageIdsChanged,
  setIsCaseDamageIdsChanges,
  damagesIds,
}) => {
  const parentIds = Array.isArray(damages) ? damages.map((x) => x.damageId) : [];

  const { data: caseDamagesData, isLoading } = useQuery(
    [QueryKey.CASE_DAMAGES],
    () =>
      getCaseDamages({
        damageIds: [...(parentIds || []), ...(damagesIds || [])],
      }),
    {
      enabled: Boolean(isCaseDamageIdsChanged),
      onSuccess: () => setIsCaseDamageIdsChanges(false),
    },
  );
  const caseDamages = caseDamagesData?.map((caseDamage) => ({
    ...caseDamage,
    ['creationDate']: caseDamage?.creationDate?.toString(),
    ['indicationDate']: caseDamage?.indicationDate?.toString(),
    ['inspectionDate']: caseDamage?.inspectionDate?.toString(),
    ['followupDate']: caseDamage?.followupDate?.toString(),
  }));

  const { data, filterValues } = useTableFilter({
    data: caseDamages?.sort(sorter(sortMetric, sortDirection)),
    filters,
    search,
  });

  return useMemo(
    () => ({
      data,
      isLoading,
      filterValues,
    }),
    [data, isLoading, filterValues],
  );
};
